"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpError = exports.ServerError = void 0;
class ServerError extends Error {
    constructor() {
        super(...arguments);
        // eslint-disable-next-line react/static-property-placement
        this.context = null;
    }
}
exports.ServerError = ServerError;
class HttpError extends Error {
    constructor(message, status, data) {
        super(message);
        this.isHttpException = true;
        this.status = status;
        this.data = data;
    }
}
exports.HttpError = HttpError;
//# sourceMappingURL=server.js.map